import { HStack, VStack, Box, Grid, GridItem, Button, useDisclosure } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { ISales } from '@partiu/api/club/types';
import { Text } from '../../../components/atoms/Text';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { numberToBRL } from '../../../utils';
import { RiInformationFill } from 'react-icons/ri';
import { InfoModal } from './InfoModal';

export function CardHistory({ fullWidth, valid_until, sale, code }: ISales) {
  const { created_at, amount, discount } = sale;
  const infoModal = useDisclosure();

  const company = discount?.company;
  const how_to_use = discount?.how_to_use || '';

  const { colors } = useTheme();

  const formattedDate = format(new Date(created_at), 'dd MMM yyyy', { locale: ptBR });
  const formattedDateValid = format(new Date(valid_until), 'dd MMM yyyy', { locale: ptBR });

  return (
    <Grid
      templateColumns={fullWidth ? '100%' : '35% 65%'}
      bg="white"
      flexDirection={fullWidth ? 'column' : 'row'}
      borderRadius={'16px'}
      boxShadow={'4px 4px 10px 0px #0000002E'}
      width={'100%'}
    >
      <GridItem>
        <Box
          backgroundRepeat={{
            base: 'round',
            md: 'no-repeat',
          }}
          style={{
            borderRadius: fullWidth ? '16px 16px 0 0' : '16px 0 0 16px',
            backgroundImage: `url(${company?.logo})`,
            width: '100%',
            backgroundPosition: 'center',
            height: fullWidth ? 140 : '100%',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain',
          }}
        />
      </GridItem>
      <GridItem>
        <VStack align={'flex-start'} height="100%" spacing="2" alignSelf={'flex-start'} padding={'10px'}>
          <HStack  justifyContent={'space-between'} width={'100%'}>
            <Text fontFamily={'Glory'} fontWeight="500" fontSize={18}>
              {company?.name}
            </Text>
            <Button onClick={() => infoModal.onOpen()} variant="ghost" color={colors.primaryColor}>
              <RiInformationFill size={20} />
            </Button>
          </HStack>

          <VStack gap={0} width={'100%'}>
            <HStack marginTop="auto" justifyContent={'space-between'} width={'100%'}>
              <HStack fontSize={11} gap={1} fontWeight={400} color="#747474">
                <Text marginTop="auto" color="#747474">
                  Preço
                </Text>
              </HStack>
              <Text fontWeight={400} fontSize={14} fontFamily={'Glory'} color={colors.primaryColor}>
                {numberToBRL(Number(amount))}
              </Text>
            </HStack>
            <HStack marginTop="auto" justifyContent={'space-between'} width={'100%'}>
              <HStack fontSize={11} gap={1} fontWeight={400} color="#747474">
                <Text marginTop="auto" color="#747474">
                  Data da compra
                </Text>
              </HStack>
              <Text fontWeight={400} fontSize={14} fontFamily={'Glory'} color={colors.primaryColor}>
                {formattedDate}
              </Text>
            </HStack>
            {code && (
              <HStack marginTop="auto" justifyContent={'space-between'} width={'100%'}>
                <HStack fontSize={11} gap={1} fontWeight={400} color="#747474">
                  <Text marginTop="auto" color="#747474">
                    Voucher
                  </Text>
                </HStack>
                <Text fontWeight={400} fontSize={14} fontFamily={'Glory'} color={colors.primaryColor}>
                  {code}
                </Text>
              </HStack>
            )}
            <HStack marginTop="auto" justifyContent={'space-between'} width={'100%'}>
              <HStack fontSize={11} gap={1} fontWeight={400} color="#747474">
                <Text marginTop="auto" color="#747474">
                  Validade do voucher
                </Text>
              </HStack>
              <Text fontWeight={400} fontSize={14} fontFamily={'Glory'} color={colors.primaryColor}>
                {formattedDateValid}
              </Text>
            </HStack>
          </VStack>
        </VStack>
      </GridItem>
      <InfoModal isOpen={infoModal.isOpen} onClose={infoModal.onClose} showName={company.name}  how_to_use={how_to_use || ''} />
    </Grid>
  );
}
